import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';
import { PageHeading } from '@hp/ui';
import { useCan } from '../api/me';
import { ErrorAlert } from '../components/error-alert';
import { Spinner } from '../components/ui/icons';
import { ContactsSection } from '../features/projects/contacts-section';
import { DeleteProjectButton } from '../features/projects/delete-project-button';
import { PhotoGallery } from '../features/projects/photo-gallery';
import { ProjectForm } from '../features/projects/project-form';
import { useProject } from '../features/projects/queries';
import { SiteSyncSection } from '../features/projects/site-sync-section';
import { UnitsSection } from '../features/projects/units-section';

function BackLink() {
  const { t } = useTranslation(['projects', 'common']);
  return (
    <Link to="/projects" className="hp-detail-action hp-detail-action--text">
      {t('detail.back')}
    </Link>
  );
}

export default function ProjectDetail() {
  const { t } = useTranslation(['projects', 'common']);
  const params = useParams();
  const id = params.id ?? '';
  const query = useProject(id);
  const canDelete = useCan()('projects.delete');

  if (query.isLoading) return <Spinner>{t('detail.loading')}</Spinner>;
  if (query.error) {
    return (
      <div className="bo-sections">
        <BackLink />
        <ErrorAlert error={query.error} />
      </div>
    );
  }
  if (!query.data) return null;
  const { project, units, photos, contacts } = query.data;

  return (
    <div className="bo-sections">
      <PageHeading
        title={project.name}
        description={project.address ?? undefined}
        actions={
          <>
            <BackLink />
            {canDelete && <DeleteProjectButton projectId={project.id} name={project.name} />}
          </>
        }
      />

      <ProjectForm key={project.id} project={project} unitCountFallback={units.length} />

      <SiteSyncSection projectId={project.id} websiteUrl={project.websiteUrl} hasAddress={Boolean(project.address)} />

      <ContactsSection projectId={project.id} contacts={contacts} />

      <UnitsSection projectId={project.id} units={units} />

      <PhotoGallery projectId={project.id} photos={photos} />
    </div>
  );
}
